import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api, { apiUrl } from '../lib/api.js';

/** Liste des justificatifs d'une transaction (métadonnées ; le flux passe par attachmentFileUrl). */
export function useTransactionAttachments(transactionId, enabled = true) {
  return useQuery({
    queryKey: ['transaction-attachments', transactionId],
    queryFn: () => api.get(`/transactions/${transactionId}/attachments`),
    enabled: Boolean(transactionId) && enabled,
    staleTime: 30_000,
  });
}

/** URL de la route backend qui streame le fichier (cible d'un <img>/<a>). */
export function attachmentFileUrl(transactionId, attachmentId) {
  return apiUrl(`/transactions/${transactionId}/attachments/${attachmentId}/file`);
}

/** Upload d'un justificatif vers Qonto (traitement asynchrone côté Qonto). */
export function useUploadTransactionAttachment(transactionId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file) => {
      const fd = new FormData();
      fd.append('file', file);
      return api.upload(`/transactions/${transactionId}/attachments`, fd);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['transaction-attachments', transactionId] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
}
